import { z } from "zod";
export const lengthDiscountTierSchema = z.object({
    min_nights: z.number().int().min(1).max(365),
    discount_percent: z.number().int().min(1).max(100),
});
export const bulkLengthDiscountsSchema = z.object({
    tiers: z.array(lengthDiscountTierSchema).max(10),
});
